import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function TextMessage(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>
                    
                    <th>{trans('tables.method_id')}</th>
                    <th>{trans('tables.partner_id')}</th>
                    <th>{trans('tables.subject')}</th>
                    <th>{trans('tables.text')}</th>
                    <th>{trans('tables.author_id')}</th>
                    <th>{trans('tables.author_type')}</th>
                    <th>{trans('tables.type')}</th>
                    <th>{trans('tables.send_at')}</th>
                    <th>{trans('tables.send_to_all')}</th>
                    <th>{trans('tables.repeat')}</th>
                    <th>{trans('tables.repeat_after')}</th>
                    <th>{trans('tables.repeat_period')}</th>
                    <th>{trans('tables.last_sent')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>
                            <td>{h.subject?.method_id ?? '-'}</td>
                            <td>{h.subject?.partner_id ?? '-'}</td>
                            <td>{h.subject?.subject ?? '-'}</td>
                            <td>{h.subject?.text ?? '-'}</td>
                            <td>{h.subject?.author_id ?? '-'}</td>
                            <td>{h.subject?.author_type ?? '-'}</td>
                            <td>{h.subject?.type ?? '-'}</td>
                            <td>{h.subject?.send_at ?? '-'}</td>
                            <td>{h.subject?.send_to_all ?? '-'}</td>
                            <td>{h.subject?.repeat ?? '-'}</td>
                            <td>{h.subject?.repeat_after ?? '-'}</td>
                            <td>{h.subject?.repeat_period ?? '-'}</td>
                            <td>{h.subject?.last_sent ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default TextMessage;